// hoc
import { withTypingTimer } from "shared/HOC/with-typing-timer";

// components
import { InputWithAddOns } from "shared/components/bulma/input";

const ITEM_NAME = 'user_search_field';

const options = [
    { value: "email", label: "Email" },
    { value: "first_name", label: "First Name" },
    { value: "last_name", label: "Last Name" },
    { value: "full_name", label: "Full Name" }
];

const CustomersFilterBar = ({ name, onChange, onSelectChange, onKeyUp }) => {
    const initialValue = localStorage.getItem(ITEM_NAME) || options[0].value;

    const handleChange = (event) => {
        const { value } = event.target;
        localStorage.setItem(ITEM_NAME, value.select);

        if (onChange) {
            onChange(event);
        }
    }

    return (
        <InputWithAddOns
            name={name}
            placeholder="Type to search"
            options={options}
            onKeyUp={onKeyUp}
            onChange={handleChange} value={initialValue}>
            Search
        </InputWithAddOns>
    );
}

const CustomersFilterBarTimed = withTypingTimer(CustomersFilterBar);

export { CustomersFilterBarTimed };
